import {
  Befehl21FormData,
  Befehl21FormSchema
} from './schema/befehl21-form.schema'
import { Befehl21 } from '../../../models'
import { BefehlAuftrag_21_10Dto } from '../../../dtos'
import {
  Befehl21DataDto,
  BefehlAuftrag_21_12Dto,
  BefehlAuftrag_21_13Dto,
  Feld_21_11Dto
} from '../../../dtos/befehl-21-dto'
import {
  createSimpleAuftrag,
  findAuftragByKennung,
  hasAuftrag
} from '../converter-utils'

export const convertModelToBefehl21FormData = (
  befehl: Befehl21 | undefined
): Befehl21FormData => {
  const formData = Befehl21FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag2110 = findAuftragByKennung(befehl.auftraege, '21.10')
  if (auftrag2110) {
    const feld2111 = auftrag2110.felder?.find(
      (f) => f.kennung === '21.11'
    ) as Feld_21_11Dto
    if (feld2111?.werte?.zugmeldestelle) {
      formData.auftrag21_10.feld21_11 = {
        art: feld2111.werte.zugmeldestelle.art || '',
        name: feld2111.werte.zugmeldestelle.name || ''
      }
    }
  }

  if (hasAuftrag(befehl.auftraege, '21.12')) {
    formData.auftrag21_12.enabled = true
  }

  if (hasAuftrag(befehl.auftraege, '21.13')) {
    formData.auftrag21_13.enabled = true
  }

  return formData
}

export const convertBefehl21FormDataToModel = (
  data: Befehl21FormData,
  frontendId: string
): Befehl21 => {
  const auftraege: Befehl21DataDto = []

  // Always include Auftrag 21.10 (it's always enabled by default)
  auftraege.push({
    kennung: '21.10',
    felder: [
      {
        kennung: '21.11',
        werte: {
          zugmeldestelle: {
            art: data.auftrag21_10?.feld21_11?.art || '',
            name: data.auftrag21_10?.feld21_11?.name || ''
          }
        }
      }
    ]
  } as BefehlAuftrag_21_10Dto)

  const auftrag2112 = createSimpleAuftrag('21.12', data.auftrag21_12?.enabled)
  if (auftrag2112) {
    auftraege.push(auftrag2112 as BefehlAuftrag_21_12Dto)
  }

  const auftrag2113 = createSimpleAuftrag('21.13', data.auftrag21_13?.enabled)
  if (auftrag2113) {
    auftraege.push(auftrag2113 as BefehlAuftrag_21_13Dto)
  }

  return {
    kennung: '21',
    frontendId,
    auftraege
  }
}
